import { Seo, Reveal, Overline } from "@/components/site/primitives";

function LegalPage({ title, updated, children, path, seoTitle }) {
  return (
    <div className="pt-36 pb-32">
      <Seo title={seoTitle} description={`${title} for ORAYA.`} path={path} />
      <div className="oraya-container max-w-3xl">
        <Reveal>
          <Overline>Legal</Overline>
          <h1 className="display text-4xl sm:text-5xl font-light tracking-tight text-ink mt-6">{title}</h1>
          <p className="text-subtle/60 text-sm mt-4">Last updated {updated}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-12 space-y-8 text-subtle leading-relaxed">{children}</div>
        </Reveal>
      </div>
    </div>
  );
}

function Block({ h, children }) {
  return (
    <section>
      <h2 className="display text-xl font-medium text-ink mb-3">{h}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}

export function Privacy() {
  return (
    <LegalPage title="Privacy Policy" updated="June 2026" path="/privacy" seoTitle="Privacy Policy — ORAYA">
      <p>This Privacy Policy explains how ORAYA PRIME SYSTEM PVT LTD ("ORAYA", "we", "us") collects, uses and protects information when you use this website.</p>
      <Block h="Information we collect">
        <p>We collect information you voluntarily provide through our contact form, such as your name, email address, company, phone number and message.</p>
      </Block>
      <Block h="How we use information">
        <p>We use submitted information solely to respond to your enquiry and to communicate with you about ORAYA systems and services.</p>
      </Block>
      <Block h="Data retention & security">
        <p>Enquiries are stored securely. We apply reasonable technical and organisational measures to protect your information and do not sell it to third parties.</p>
      </Block>
      <Block h="Contact">
        <p>For privacy questions, contact us via the contact page.</p>
      </Block>
    </LegalPage>
  );
}

export function Terms() {
  return (
    <LegalPage title="Terms of Service" updated="June 2026" path="/terms" seoTitle="Terms of Service — ORAYA">
      <p>These Terms of Service govern your use of the ORAYA website, operated by ORAYA PRIME SYSTEM PVT LTD.</p>
      <Block h="Use of the website">
        <p>You agree to use this website lawfully and not to misuse, disrupt or attempt unauthorised access to any part of it.</p>
      </Block>
      <Block h="Intellectual property">
        <p>The ORAYA brand, content, design and visual identity are the property of ORAYA and may not be reproduced without permission.</p>
      </Block>
      <Block h="No warranties">
        <p>This website is provided "as is". Information is provided for general purposes and may change without notice.</p>
      </Block>
      <Block h="Contact">
        <p>For questions about these terms, contact us via the contact page.</p>
      </Block>
    </LegalPage>
  );
}
